module.exports = __webpack_public_path__ + "static/media/third_circle.5c87e326.png";